/**
 * Legal brands control the policies and terms of service that are displayed to and are
 * required to be accepted by the user. This is less bound by country and more by which
 * legal entity services that country.
 */
export enum LegalBrand {
  FARMBOT = 'farmbot',
  RANCHBOT = 'ranchbot'
}
